<template>
  <div>
    <div>
      <router-view/>
    </div>
  </div>

</template>

<script>
import {mapState, mapActions, mapMutations} from 'vuex'

export default {
  computed: mapState([
    'poster', 'status', 'user'
  ]),
  methods: {
    ...mapActions([
      'GET_USERDATA'
    ]),
    ...mapMutations([
      'SET_USER'
    ]),
  },
  created() {
    this.$store.dispatch('GET_ONE_POSTER', this.$route.params.id);
    if (!this.user || !this.user.id) {
      this.GET_USERDATA().then((result) => {
        this.SET_USER({user: result.data})
      })
    }
  }
}
</script>

